import { Separator } from "@/components/ui";
import { getDisplay } from "@curai/js-fhir-tools";
import type * as fhirTypes from "fhir/r4";
import { SubjectiveAddendum } from "./SubjectiveAddendum";
import { type Addendum, parseAddendumStatus } from "./types";

interface SubjectiveAddendumsProps {
  documentReferences: fhirTypes.DocumentReference[];
  onAddAddendum: (addendum: Addendum) => void;
  addedAddendums: Addendum[];
  canWriteSubjective: boolean;
}

export const SubjectiveAddendums = ({
  documentReferences,
  onAddAddendum,
  addedAddendums,
  canWriteSubjective,
}: SubjectiveAddendumsProps) => {
  const addendumExtensions = documentReferences.flatMap((docRef) =>
    (docRef.extension || [])
      .filter(
        (ext) =>
          ext.url ===
          "https://fhir-ig.curaihealth.com/StructureDefinition/subjective-addendum-metadata",
      )
      .map((ext) => ({ docRefId: docRef.id, extension: ext })),
  );

  if (!addendumExtensions.length) {
    return null;
  }

  return (
    <div className="mt-4">
      <Separator />
      {addendumExtensions.map(({ extension }) => {
        const addendum = extension.extension || [];
        const noteExt = addendum.find((ext) => ext.url === "note");
        const note = noteExt?.valueAnnotation;
        const summary = note?.text;
        const author = note?.authorString;
        const time = note?.time;
        const identifierExt = addendum.find((ext) => ext.url === "identifier");
        const identifierValue = identifierExt?.valueIdentifier?.value;
        const statusExt = addendum.find((ext) => ext.url === "status");
        const status = parseAddendumStatus(
          statusExt?.valueCodeableConcept
            ? getDisplay(statusExt.valueCodeableConcept)
            : undefined,
        );

        if (!identifierValue || !summary) {
          return null;
        }

        return (
          <SubjectiveAddendum
            key={identifierValue}
            summary={summary}
            author={author}
            time={time}
            status={status}
            addendumId={identifierValue}
            onAddAddendum={onAddAddendum}
            addedAddendums={addedAddendums}
            canWriteSubjective={canWriteSubjective}
          />
        );
      })}
    </div>
  );
};
